var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import React from 'react';
import { Link } from 'react-router-dom';
import { withRouter, } from 'react-router';
import Icon from 'antd/lib/icon';
import Menu from 'antd/lib/menu';
import 'antd/lib/menu/style/index.css';
import FaCube from 'react-icons/lib/fa/cube';
import FaListOl from 'react-icons/lib/fa/list-ol';
var Item = Menu.Item, ItemGroup = Menu.ItemGroup, SubMenu = Menu.SubMenu;
import MenuItemGroupBottom from './MenuItemGroupBottom';
import MenuWorkspaceEventSelect from './MenuWorkspaceEventSelect';
import MenuWorkspaceEventRoleBadge from './MenuWorkspaceEventRoleBadge';
import 'src/imports/styles/extend.menu.scss';
var selfStyles = require('./styles.scss');
function generateMenuItem(item) {
    if (item.items === undefined) {
        return (React.createElement(Item, { key: item.key, className: selfStyles.menuItem, disabled: item.disabled },
            React.createElement(Link, { to: item.linkTo }, item.title)));
    }
    return (React.createElement(SubMenu, { key: item.key, title: item.title, className: selfStyles.menuItem, disabled: item.disabled }, item.items.map(function (i) { return generateMenuItem(i); })));
}
function generateMenu(subdomain) {
    var isDisabled = !subdomain || (subdomain === 'new');
    var menuStructure = [{
            key: 'dashboard',
            title: React.createElement("span", { className: selfStyles.menuItemIcon },
                React.createElement(FaListOl, { className: 'anticon' }),
                React.createElement("span", null, "Dashboard")),
            linkTo: "/event/" + subdomain,
            disabled: isDisabled,
        }, {
            key: 'event',
            title: React.createElement("span", { className: selfStyles.menuItemIcon },
                React.createElement(FaCube, { className: 'anticon' }),
                React.createElement("span", null, "Event Setup")),
            linkTo: "/event/" + subdomain + "/event",
            disabled: isDisabled,
            items: [{
                    key: '/event/:subdomain/event',
                    title: 'Event',
                    linkTo: "/event/" + subdomain + "/event",
                    disabled: isDisabled,
                }, {
                    key: '/event/:subdomain/categories',
                    title: 'Categories',
                    linkTo: "/event/" + subdomain + "/categories",
                    disabled: isDisabled,
                }, {
                    key: '/event/:subdomain/rounds',
                    title: 'Rounds & Routes',
                    linkTo: "/event/" + subdomain + "/rounds",
                    disabled: isDisabled,
                }, {
                    key: '/event/:subdomain/crew',
                    title: React.createElement("div", null,
                        "Crew & Judges ",
                        React.createElement(MenuWorkspaceEventRoleBadge, null)),
                    linkTo: "/event/" + subdomain + "/crew",
                    disabled: isDisabled,
                }],
        }, {
            key: 'participants',
            title: React.createElement("span", { className: selfStyles.menuItemIcon },
                React.createElement(Icon, { type: 'team' }),
                React.createElement("span", null, "Participants")),
            linkTo: "/event/" + subdomain + "/athletes",
            disabled: isDisabled,
            items: [{
                    key: '/event/:subdomain/athletes',
                    title: 'Athletes',
                    linkTo: "/event/" + subdomain + "/athletes",
                    disabled: isDisabled,
                }, {
                    key: '/event/:subdomain/teams',
                    title: 'Teams',
                    linkTo: "/event/" + subdomain + "/teams",
                    disabled: isDisabled,
                }, {
                    key: '/event/:subdomain/scorecard',
                    title: 'Scorecards',
                    linkTo: "/event/" + subdomain + "/scorecard",
                    disabled: isDisabled,
                }],
        },
    ];
    return menuStructure.map(function (item) { return generateMenuItem(item); });
}
var MenuWorkspaceEvent = (function (_super) {
    __extends(MenuWorkspaceEvent, _super);
    function MenuWorkspaceEvent(props) {
        var _this = _super.call(this, props) || this;
        _this.state = _this.getMenuState(_this.props);
        _this.handleOpen = _this.handleOpen.bind(_this);
        return _this;
    }
    MenuWorkspaceEvent.prototype.componentWillReceiveProps = function (nextProps) {
        this.setState(this.getMenuState(nextProps));
    };
    MenuWorkspaceEvent.prototype.getMenuState = function (nextProps) {
        var currentOpenKey;
        var currentSelectedKey;
        switch (nextProps.match.path) {
            case ('/event/:subdomain'):
                var isCreateNewEvent = nextProps.match.url === '/event/new';
                currentOpenKey = isCreateNewEvent ? 'event' : 'dashboard';
                currentSelectedKey = isCreateNewEvent ? '/event/:subdomain/event' : 'dashboard';
                break;
            case ('/event/:subdomain/event'):
                currentOpenKey = 'event';
                currentSelectedKey = '/event/:subdomain/event';
                break;
            case ('/event/:subdomain/categories'):
            case ('/event/:subdomain/categories/new'):
            case ('/event/:subdomain/categories/:categoryId'):
                currentOpenKey = 'event';
                currentSelectedKey = '/event/:subdomain/categories';
                break;
            case ('/event/:subdomain/rounds'):
            case ('/event/:subdomain/rounds/new'):
            case ('/event/:subdomain/rounds/:roundId'):
                currentOpenKey = 'event';
                currentSelectedKey = '/event/:subdomain/rounds';
                break;
            case ('/event/:subdomain/crew'):
                currentOpenKey = 'event';
                currentSelectedKey = '/event/:subdomain/crew';
                break;
            case ('/event/:subdomain/athletes'):
            case ('/event/:subdomain/athletes/new'):
            case ('/event/:subdomain/athletes/:athleteId'):
                currentOpenKey = 'participants';
                currentSelectedKey = '/event/:subdomain/athletes';
                break;
            case ('/event/:subdomain/teams'):
            case ('/event/:subdomain/teams/new'):
            case ('/event/:subdomain/teams/:teamId'):
                currentOpenKey = 'participants';
                currentSelectedKey = '/event/:subdomain/teams';
                break;
            case ('/event/:subdomain/scorecard'):
                currentOpenKey = 'participants';
                currentSelectedKey = '/event/:subdomain/scorecard';
                break;
            default:
                currentOpenKey = '';
                currentSelectedKey = '';
        }
        return {
            openKeys: [currentOpenKey],
            selectedKeys: [currentSelectedKey],
        };
    };
    MenuWorkspaceEvent.prototype.handleSelect = function (_a) {
        var selectedKeys = _a.selectedKeys;
    };
    MenuWorkspaceEvent.prototype.handleOpen = function (openKeys) {
        var _this = this;
        var latestOpenKey = openKeys.find(function (key) { return _this.state.openKeys.indexOf(key) === -1; });
        this.setState({ openKeys: latestOpenKey ? [latestOpenKey] : [] });
    };
    MenuWorkspaceEvent.prototype.render = function () {
        return (React.createElement(Menu, { mode: 'inline', defaultOpenKeys: ['event', 'participants'], selectedKeys: this.state.selectedKeys, onSelect: this.handleSelect, inlineIndent: 30, className: selfStyles.menu },
            React.createElement(ItemGroup, { title: React.createElement(MenuWorkspaceEventSelect, __assign({}, this.props)) }),
            generateMenu(this.props.match.params.subdomain),
            React.createElement(MenuItemGroupBottom, null)));
    };
    return MenuWorkspaceEvent;
}(React.Component));
export default withRouter(MenuWorkspaceEvent);



//////////////////
// WEBPACK FOOTER
// ./src/pages/templates/components/PageMenu/MenuWorkspaceEvent.tsx
// module id = 806
// module chunks = 0